export default __webpack_public_path__ + "static/media/phenyl.14f5129c.png";